import type { ReactNode } from "react";

interface CardProps {
  title?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Drop the default body padding — useful when the body is a table. */
  flush?: boolean;
}

export function Card({ title, actions, footer, children, className, flush }: CardProps) {
  return (
    <section className={["card", className].filter(Boolean).join(" ")}>
      {(title || actions) && (
        <header className="card__header">
          {typeof title === "string" ? <h2 className="card__title">{title}</h2> : title}
          {actions ? <div className="row">{actions}</div> : null}
        </header>
      )}
      <div className={flush ? undefined : "card__body"}>{children}</div>
      {footer ? <footer className="card__footer">{footer}</footer> : null}
    </section>
  );
}
